const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

export async function submitLead({
  fullName, email, phone, company, message, topic, wantsDemo,
  demoDate, demoStartTime,
}) {
  if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
    throw new Error('Booking is not configured (missing REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY).');
  }

  const res = await fetch(`${SUPABASE_URL}/functions/v1/book-demo`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
      apikey: SUPABASE_ANON_KEY,
    },
    body: JSON.stringify({
      fullName, email, phone, company, message, topic, wantsDemo, demoDate, demoStartTime,
    }),
  });

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new Error(data.error || 'Something went wrong. Please try again.');
  }

  return data;
}
